<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
      <sub-tabs nomeSessao="Negócios"></sub-tabs>
  </v-container>
</template>

<script>
import subTabs from '@/components/painel/SubTabs'
export default {
  name: 'PNegocios',
  components: {
    'sub-tabs': subTabs
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?9e8e8c00